export enum CreatureSizes {
    Tiny = -2,
    Small = -1,
    Medium = 0,
    Large = 1,
    Huge = 2,
    Gargantuan = 3,
}
